// import GaugeWidget from './GaugeWidget'
import TextWidget from './TextWidget'
import ImageWidget from './ImageWidget'
import VideoWidget from './VideoWidget'
import ChartWidget from '../widgets2/Chart'
// import TableWidget from './TableWidget'
// import NetworkMapWidget from './NetworkMapWidget'
import ValueWidget from './ValueWidget'
import SliderWidget from './SliderWidget'
import TriggerWidget from './TriggerWidget'
import StatusSwitcherWidget from './StatusSwitcherWidget'
import MapWidget from './MapWidget'
import MapLeafletWidget from './MapLeafletWidget'
// import IndoorMapWidget from './IndoorMapWidget'
import ProgressChart from "../widgets2/ProgressChart"
import UpdatesWidget from "../widgets2/UpdatesWidget"
import ViewSwitcherWidget from "../widgets2/ViewSwitcherWidget"
import QuizPageWidget from '../widgets2/QuizPageWidget'
import ButtonWidget from './ButtonWidget'
import FileWidget from './FileWidget'
import FormWidget from '../widgets2/FormWidget'
import ProductsWidget from '../widgets2/ProductsWidget'
import TasksWidget from '../widgets2/TasksWidget'
import ProjectsWidget from '../widgets2/ProjectsWidget'
import DashboardsWidget from '../widgets2/DashboardsWidget'
import AccoutSettingWidget from '../widgets2/AccoutSettingWidget'
import RecentlyWidget from './RecentlyWidget'
import AvailableTimesWidget from './AvailableTimesWidget'
import InvoiceWidget from './InvoiceWidget'

// import SliderWidget from './SliderWidget'

// import ListWidget from "../widgets2/ListView"

const WidgetComponents = {
    // GaugeWidget,
    TextWidget,
    ImageWidget,
    VideoWidget,
    ViewSwitcherWidget,
    ChartWidget,
    FileWidget,
    FormWidget,
    ProductsWidget,
    TasksWidget,
    ProjectsWidget,
    AccoutSettingWidget,
    // TableWidget,
    // NetworkMapWidget,
    ValueWidget,
    SliderWidget,
    TriggerWidget,
    StatusSwitcherWidget,
    MapWidget,
    MapLeafletWidget,
    // IndoorMapWidget,
    DashboardsWidget,
    ProgressChart,
    UpdatesWidget,
    QuizPageWidget,
    ButtonWidget,
    RecentlyWidget,
    AvailableTimesWidget,
    InvoiceWidget
    // SliderWidget
    // ListWidget



}

export default WidgetComponents;